var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
const SvgBell = _ref => {
  let {
    svgRef,
    title,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "22px",
    height: "22px",
    viewBox: "5 6 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop-User-Profile",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-User-Profile---Icons"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icon-/-Location-/-Black-Background"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group",
    transform: "translate(8.000000, 8.000000)",
    stroke: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.4340016,12.0800977 C12.8044779,12.0809541 12.9190148,11.8337977 12.6892924,11.5307786 L11.7177958,10.2504281 C11.4880735,9.947409 11.2997611,9.38471767 11.2988744,8.99950805 L11.2932339,6.54898219 C11.2923478,6.1640195 11.2838105,5.65137733 11.2744733,5.40986017 L11.2426577,5.19792227 C11.2045766,4.94473289 11.1461013,4.69865715 11.0674755,4.46241182 C10.6958347,3.33704071 9.89081533,2.41289918 8.8705265,1.89692447 C8.30692084,1.61214499 7.67785934,1.45117164 7.01902377,1.44963375 C6.40979073,1.44823277 5.82555404,1.58318296 5.29758022,1.82789955 C4.39526048,2.24657352 3.65268856,2.98489555 3.21479151,3.90393415 C3.06741035,4.21398099 2.95330295,4.54459996 2.88029105,4.89136449 L2.81666845,5.19296297 C2.79848722,5.54281771 2.78420783,6.14430105 2.78556859,6.52926485 L2.79414924,9.01979984 C2.79551057,9.40501057 2.60788452,9.96534905 2.37765152,10.2653268 L1.42169317,11.5081219 C1.19146017,11.8080996 1.3054713,12.054304 1.67523565,12.055161 L12.4340016,12.0800977 Z",
    id: "Stroke-1",
    transform: "translate(7.055218, 6.764866) rotate(17.000000) translate(-7.055218, -6.764866) "
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.17850099,11.8040141 C7.18062766,12.7296625 6.32407441,13.4785445 5.26509247,13.4760963 C4.20483218,13.473633 3.34558925,12.7207744 3.34345861,11.795126",
    id: "Stroke-3",
    transform: "translate(5.260980, 12.635611) rotate(17.000000) translate(-5.260980, -12.635611) "
  })))))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgBell, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/bell.623b3d0d.svg";
export { ForwardRef as ReactComponent };